import { IStorageObject } from "../models/imports"
import { omniaResolve } from "../promises"
import { IOmniaHttpService } from "../types"
import { isArrayEmpty } from "../utils/array"
import { normalizePath } from "./appFiles"
import { AppFilesState, IExportTarget, IFolderContent, IStorageBoundariesSource } from "./types"

interface Context {

    readonly connectionId: string

    readonly cache: Map<string, IFolderContent>

}

export class AppFilesService {

    private readonly connectionState = new Map<string, AppFilesState>

    constructor(private ohttp: IOmniaHttpService) {
    }

    getFolderContent(context: Context, path: string): ng.IPromise<IFolderContent> {

        const { connectionId, cache } = context

        const filesFromCache = cache.get(path);

        if (filesFromCache) {
            return omniaResolve(filesFromCache)
        }

        const url = `/api/storage/folder/contents?connectionId=${connectionId}&path=${encodeURIComponent(path)}&levels=1`

        return this.ohttp.get(url, false)
            .then(r => {

                if (r.data) {

                    const result: IFolderContent = {
                        path,
                        content: r.data
                    }

                    return result
                }

            })
            .then(r => {

                if (r) {
                    cacheFolderContent(cache, path, r)
                }

                return r

            })

    }

    getConnectionState(connectionId: string) {
        return this.connectionState.get(connectionId)
    }

    setConnectionState(connectionId: string, state: AppFilesState) {
        this.connectionState.set(connectionId, state)
    }

    getBoundariesSources(connectionId: string, holdingId: number): ng.IPromise<IStorageBoundariesSource[]> {
        const url = `/api/storage/boundaries/source?connectionId=${connectionId}&holdingId=${holdingId}`
        return this.ohttp.get(url).then(r => r.data)
    }

    sendFile(target: IExportTarget): ng.IPromise<any> {
        const url = "/api/apps/export"
        return this.ohttp.post(url, target)
    }

}

function cloneFolderContent(f: IFolderContent) {
    return {
        ...f,
        content: cloneStorageObjArray(f.content)
    }
}

function cloneStorageObjArray(o: IStorageObject[]) {
    return isArrayEmpty(o)
        ? o
        : o.map(e => ({
            ...e,
            Contents: cloneStorageObjArray(e.Contents)
        }))
}

function cacheFolderContent(cache: Map<string, IFolderContent>, path: string, content: IFolderContent) {

    cache.set(path, content)

    if (content.content) {

        for (const c of content.content) {

            if (c.Contents && c.Contents.length) {
                cacheFolderContent(cache, normalizePath(c.Path), <IFolderContent>{
                    name: c.Name,
                    path: c.Path,
                    content: c.Contents
                });
            }

        }

    }

}
